<template>
  <div class="mt-6">
    <div class="text-center">
      <ion-text class="text-lg font-bold ion-text-brand"
        >MFA Settings Updated</ion-text
      >
    </div>
    <div class="text-md ion-text-brand my-6 text-center">
        {{ mfaUpdatedMsg }}
      </div>
  </div>
</template>
<script setup>
import { useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
const customerStore = useCustomerStore();
const {
  mfaUpdatedMsg
} = storeToRefs(customerStore);
</script>